import { createFragmentRegistry } from '@apollo/client/cache';

import ACV_ESTIMATES_FRAGMENT from '@/api/graphql/definitions/fragments/acvEstimatesFragment';
import AUCTION_FRAGMENT from '@/api/graphql/definitions/fragments/auctionFragment';
import BUYER_INFO_FRAGMENT from '@/api/graphql/definitions/fragments/buyerInfoFragment';
import DEALERSHIP_CLAIM_FRAGMENT from '@/api/graphql/definitions/fragments/dealershipClaimFragment';
import DEALERSHIP_MEMBER_BID_FRAGMENT from '@/api/graphql/definitions/fragments/dealershipMemberBidFragment';
import IMAGE_FRAGMENT from '@/api/graphql/definitions/fragments/imageFragment';
import MY_AUCTION_CLAIM_FRAGMENT from '@/api/graphql/definitions/fragments/myAuctionClaimFragment';
import NEGOTIATION_INFO_FRAGMENT from '@/api/graphql/definitions/fragments/negotiationInfoFragment';
import PENDING_OFFER_FRAGMENT from '@/api/graphql/definitions/fragments/pendingOfferFragment';
import POST_INSPECTION_FRAGMENT from '@/api/graphql/definitions/fragments/postInspectionFragment';
import PROXY_BID_FRAGMENT from '@/api/graphql/definitions/fragments/proxyBidFragment';
import SELLER_FRAGMENT from '@/api/graphql/definitions/fragments/sellerFragment';
import SELLER_STATUS_FRAGMENT from '@/api/graphql/definitions/fragments/sellerStatusFragment';

const fragmentRegistry = createFragmentRegistry();

export const registerFragments = () => {
  [
    ACV_ESTIMATES_FRAGMENT,
    AUCTION_FRAGMENT,
    BUYER_INFO_FRAGMENT,
    DEALERSHIP_CLAIM_FRAGMENT,
    DEALERSHIP_MEMBER_BID_FRAGMENT,
    IMAGE_FRAGMENT,
    MY_AUCTION_CLAIM_FRAGMENT,
    NEGOTIATION_INFO_FRAGMENT,
    PENDING_OFFER_FRAGMENT,
    POST_INSPECTION_FRAGMENT,
    PROXY_BID_FRAGMENT,
    SELLER_FRAGMENT,
    SELLER_STATUS_FRAGMENT,
  ].forEach((fragment) => fragmentRegistry.register(fragment));
};

export default fragmentRegistry;
